<template>
  <div>
    <v-runtime-template :template="includeTemplate"/>
    <wep-loading :is-loading="isLoading"/>
  </div>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'
import WepLoading from '~pages/contents/loading/WepLoading.vue'
import normalize from 'normalize-path'
export default {
  name: 'OauthInfo',
  metaInfo () {
  },
  components: {
    VRuntimeTemplate, 'wep-loading': WepLoading
  },
  data () {
    return {
      includeHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath,
      ptptConfmMsg: '',
      wepSets: this.getStore('mmpAuth').state.wepSets,
      isLoading: false
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  watch: {
    // 'mbrFnm': {
    //   handler: function (newVal, oldVal) {
    //     if (isEmpty(this.newVal) && this.loginErr) {
    //       this.loginErr = false
    //     }
    //   }
    // }
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    if (isEmpty(wepHtmlToString.mainTemplate)) {
      this.getEmptyTemplate('wepPtptConfm.html')
    } else {
      this.includeHtml = wepHtmlToString.mainTemplate
    }
    this.fnSsoLogin()
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.mainTemplate = res
        this.includeHtml = wepHtmlToString.mainTemplate
      })
    },
    openNotice () {
      document.querySelectorAll('.notice-item')[0].classList.toggle('opened')
    },
    async fnSsoLogin () {
      // this.ptptConfmMsg = this.$t('WEP00040')
      // let params = {'access_token': 'eyJraWQiOiI5MCIsImN0eSI6IkpXVCIsImVuYyI6IkEyNTZHQ00iLCJhbGciOiJSU0EtT0FFUC0yNTYifQ.lG6d-i_iYkiBzoOEOqViVMENfLNCcwqhqAiAvTn-Jh30Dib_Xjsd4wT2MIw1F0X9ESxYHCGERSPgJXHN5blOBpx-2LGLsLOLB5wzGHtHqcoLUR7JFMhatJV-_eQrZyLpkBwIC0LlmbqyjA_PVLhoU_z-MWoZwX2EU5g8UwsEaXXo0NYDzrULvKfV8xL3AMLzMZlrpoGj5UwrnX4IDNzrOTMa-oDyr7twH0DQYbhG_JA0wtNDGIMzALQZEICcGwCtDy_SKlA0RchztWDR1t-aKimhWC-9Hk8bqqWjWbzcfu4ndpM_fRsCuxsqwc1zuS1qPh-05rbizYibU8RSf9ZJag.WKz3OUGp8mjQg7Lm.zykYwcPlf9d7s09L2zHA4HQ8xXL1ZioCCm457pfTkzfBsq5cVBDXX0cCsGtL6gCOnEeyyzGOUGbiLoqmae79ik3pdAIbqTuG40colaXgsTFD3WEeccI9tS5Nn_d9tpLQZ_eoqBJv_GBMnpDPcnRYrNUGGWCTIAFv5h5-CqHgbghTJjRYeFoXv9AoDnhPrSgTyUv5Ia-91L9TQ58d02yuyAuBl2KCb5c0L22osB48ydlsu-IsTbv9Pbblg4MqV_QyENhYoCi3E_FwRaegxo2AYWtdGJGFQSH8gdn5FjwpCcaSoHXSHTz1cC5O-a0eVTZtpeMn7qYUcJM5DYq90udzg2asUPPq_h1UUj1MaJMxslqjP8P0dWsnT-yADK4plhmNlQZylLthU7gQawFIGUNMETN_zrLlYtUN9XM3uYhFKTuoidykX0DhJXucMp5oxccFpgrFdt03VhCKATJwFeRu4PrG4gA4eNJdC3RXK-N3IIPY_-2ppHL1lGJC4jT53yxd1mvwQpnBDFLex7YM1dhgtdMHZw7ONOI4sYINGkOfcyIAKEc4HXWCz8fLHvXBDzKztMMDvCbyYbYs603jZVeByJt2RgBLoE--8e1r1wi0cP5BJRMc2CPNIzp5rifPYt_L5cmg8hWFtFrYXsc1t9uGM25AX6FSpIuKV7pOOXR8bHgvCPftgEkj8YtZcWCAdok7fEGRYEgvhGLj3hwGinx93WnztJjRaXJbJmV0Mj1DqBVont_zCWB84AT6t6l3etGCSa5nBcI3n1FOWzfV3_9gHQkWBRmvLcMa1TNz0KsYOzwl_mj4CGsAPr5Skp6b9o_lbvmxMSAdMGSc3mOX4fkXeEQp1cK-jhYLC8j_QXjl_xXeGrmMz7aPWNyES4_LHogWGOHVLecO_6ya4YakjS29ehej4tfQkdMsyWw3pnCiaDhBpALN1fAVYKWRHSwqjKJ09tNnUw3Zl1xect80Xkjj1sbhlUCCyPWNXzGQce08JxTvnVPkXWwCAe5SiibmLM3ZWLSI-Ftta9dGNRpHm77fSpKCfgQVuhWzfuWXgLJCtgrKDzo1qOe_9ZIoTWElM8uwTVTHtZgo5sBlNgbgsUkpVup-0IElWr-Qup9JFgdl2MsDuqUMgpr_xazMhs4jE3RJEbu_DESoPzxJDrnlZftR_jTFpDsGOE__KFzUUSViKk2ryndTZVxSw47KV6z25ELrK_9m_aYFgh1CkJ5o5o1Jq5imV-mR3Sfrfl4So14bSAHetnOgB_DdkiKj0dIq78Gq2qRttFf3kwnGTPJuI5vdAsD1-dutkXcpa1eYvfdh0HcQjbn6iUJzSsRmPc4e5FjBBayLI36-5Dn9g07v0309A6mcKAZytkucDOF8ds4sgaSkJuhBUCGP_8B1_DyjgQ0EpO1hKIEH_va1WLYMtGLIUOLd3v_b3zXrAWiPMxzP3SVJKc6SmHpWBv2zFEYXJhBR0Xo2xTgSgrPUbJgabJbzpa4onw0r2b0WnN2a0x6BaaEz206gK2N7DGMxWpwAIpFWzjYPs6qaPg.E8FicwtH5Q0Y7EuJUcMyJQ'}
      // alert(this.$route.query.access_token)
      // let options = {
      //   method: 'POST',
      //   headers: {'content-type': 'appliaction/x-www-form-urlencoded'},
      //   data: qs.stringify(params),
      //   url: 'http://localhost:8080/v1/anonym/oauth2/classnow'
      // }
      let url = 'mmp/v1/anonym/oauth2/classnow'
      let requestUri = window.vue.config.http.mmp.baseURI + normalize('/' + url)
      let xhr = new XMLHttpRequest()
      xhr.open('post', requestUri, true)
      let _this = this
      this.ptptConfmMsg = this.$t('WEP00040')
      xhr.onload = function () {
        console.log(xhr.statusText)
        if (xhr.statusText !== 'OK') {
          _this.ptptConfmMsg = _this.$t('WEP00031')
        } else {
          let resultInfo = JSON.parse(xhr.response)
          console.log(resultInfo.status)
          console.log(resultInfo.data)
          console.log(resultInfo.data.wepId)
          _this.isLoading = true
          if (resultInfo.data.wepAplConfmCd === 'S') {
            let session = Object.assign({}, {
              loginTime: new Date().getTime(),
              timeout: window.vue.config.session.timeout,
              authenticated: true,
              wepId: resultInfo.data.wepId,
              userId: resultInfo.data.wepApcId,
              mbrFnm: resultInfo.data.mbrFnm,
              emailAddr: resultInfo.data.emailAddr,
              wepApcTyp: resultInfo.data.wepApcTyp,
              excsTitlNm: resultInfo.data.excsTitlNm,
              cmntRpatInqrTm: resultInfo.data.cmntRpatInqrTm,
              cmntInqrCnt: resultInfo.data.cmntInqrCnt
            })

            _this.getStore('root').commit('LOG_IN', session)
            let token = Object.assign({}, {
              tokenAuth: resultInfo.data.mbrToken
            })
            _this.getStore('token').commit('REGISTER', token)
            _this.getStore('mmpAuth').commit('SET_AUTO_LOGIN', {session: session, token: token})
            _this.isLoading = false

            if (_this.wepSets.videoTrnsTyp === '02' ) {
              _this.getTemplate('wepAgenda.html', '0', 'classnow')
            } else if (_this.wepSets.videoTrnsTyp === '03' ) {
              _this.getTemplate('wepAgenda.html', '0', 'classnow')
            } else {
              _this.getTemplate('wepEnter.html', '0', 'enter')
            }
          } else if (resultInfo.data.wepAplConfmCd === 'A') {
            _this.ptptConfmMsg = _this.$t('WEP00024')
            _this.isLoading = false
          } else if (resultInfo.data.wepAplConfmCd === 'C') {
            _this.ptptConfmMsg = _this.$t('WEP00025')
            _this.isLoading = false
          } else if (resultInfo.data.rtCd === '99') {
            _this.ptptConfmMsg = _this.$t('WEP00034')
            _this.isLoading = false
          } else if (resultInfo.data.rtCd === '98') {
            _this.ptptConfmMsg = _this.$t('WEP00041')
            _this.isLoading = false
          } else {
            _this.ptptConfmMsg = _this.$t('WEP00033')
            _this.isLoading = false
          }
        }
      }
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
  		xhr.send('access_token=' + this.$route.query.access_token)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/OauthInfo.vue